import React, { useState } from "react";
import { useFormik } from "formik";

import * as Yup from "yup";
import Context from "../../../../context";
import { City, IItem, ILocation } from "../../../../types/common.interface";
import values from "../../../../values";
import validations from "../../../../validations";
import {
  CustomButton2,
  CustomIcon,
  CustomInput,
  CustomModal,
  CustomView,
} from "../../../../components";
import TitleLine from "../../../../components/TitleLine";
import CustomDropDownSearch from "../../../../components/CustomDropDownSearch";
import "./index.sass";
import { ICreateAndUpdateMunicipality } from "../../../../types/municipality.interface";
import { ICreateAndUpdateWorkTime } from "../../../../types/workTime.interface";

const Create = () => {
  const { showModal, loading, setShowModal, createMunicipality } =
    React.useContext(Context?.MunicipalityScreen);

  const [selectedCities, setSelectedCities] = useState<City>();
  const [selectedLocation, setSelectedLocation] = useState<ILocation>();
  const [selectedImage, setSelectedImage] = useState<any>();
  const [selectedMunicipality, setSelectedMunicipality] =
    useState<ICreateAndUpdateMunicipality>();
  const [selectedWorkTimes, setSelectedWorkTimes] = useState<
    ICreateAndUpdateWorkTime[]
  >([]);
  const [errors, setErrors] = React.useState<any>({});

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  const formik = useFormik<ICreateAndUpdateMunicipality>({
    enableReinitialize: true,
    initialValues: {
      name: "",
      userName: "",
      password: "",
      rePassword: "",
    },
    validationSchema: Yup.object({
      name: validations?.yupValidations?.companyName,
      userName: validations.yupValidations.userName,
      password: Yup.string().required("فیلد گذرواژه اجباری است"),
    }),
    onSubmit: (values: ICreateAndUpdateMunicipality, { setSubmitting }) => {
      const formValues: ICreateAndUpdateMunicipality = {
        cities: selectedCities?._id as string,
        ...values,
      };

      createMunicipality!(formValues);
    },
  });

  const submitHandler = () => {
    if (formik.values.password === formik.values.rePassword) {
      setErrors({ rePassword: "" });
      formik.submitForm();
    } else {
      setErrors({ rePassword: "تکرار گذرواژه اشتباه است" });
    }
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <>
      <CustomIcon icon="fa fa-add" onClick={() => setShowModal!("CREATE")} />
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "CREATE"}
        minWidth={"35rem"}
        maxWidth={"40rem"}
        maxHeight={"75vh"}
      >
        <form onSubmit={submitHandler}>
          <CustomView.Container className="update-form-content">
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="name"
                  id="name"
                  label="نام شهرداری"
                  value={formik.values.name}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.name && formik.touched.name}
                  errorText={formik.errors.name}
                />
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <CustomDropDownSearch
                  itemName="name"
                  items={[values?.constants?.hardCodeCity]}
                  placeHolder="انتخاب شهر"
                  onSelectItem={(event) => setSelectedCities(event)}
                  defaultItem={selectedCities}
                  label="شهر"
                />
              </CustomView.Column>
            </CustomView.Row>
            <TitleLine title="اطلاعات ورود به سامانه" />
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <div className="enter-number-container">
                  <CustomInput
                    name="userName"
                    id="userName"
                    value={formik.values.userName}
                    onValueChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    label="نام کاربری"
                    placeHolder="نام کاربری"
                    textAlign="center"
                    error={formik.errors.userName && formik.touched.userName}
                    errorText={formik.errors.userName}
                  />
                </div>
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <div className="enter-number-container">
                  <CustomInput
                    type="password"
                    name="password"
                    id="password"
                    value={formik.values.password}
                    onValueChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    label="گذرواژه"
                    placeHolder="گذرواژه"
                    textAlign="center"
                    error={formik.errors.password && formik.touched.password}
                    errorText={formik.errors.password}
                    isPassword
                  />
                </div>
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <div className="enter-number-container">
                  <CustomInput
                    type="password"
                    name="rePassword"
                    id="rePassword"
                    value={formik.values.rePassword}
                    onValueChange={(event) => {
                      formik.values.password === event.target.value
                        ? setErrors({ rePassword: "" })
                        : setErrors({
                            rePassword: "تکرار گذرواژه اشتباه است",
                          });
                      formik.handleChange(event);
                    }}
                    onBlur={formik.handleBlur}
                    label="تکرار گذرواژه"
                    placeHolder="تکرار گذرواژه"
                    textAlign="center"
                    isPassword
                  />
                </div>
                <div className="error">
                  {errors.rePassword !== "" && errors.rePassword}
                </div>
              </CustomView.Column>{" "}
            </CustomView.Row>
            <CustomView.Row className="form-row buttons-row">
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={loading}
                  onClick={() => setShowModal!("NONE")}
                  title="لغو"
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={loading}
                  onClick={submitHandler}
                  title="ساخت شهرداری"
                />
              </CustomView.Column>
            </CustomView.Row>
          </CustomView.Container>
        </form>
      </CustomModal>
    </>
  );
};

const gender: IItem[] = [
  { _id: "0", name: "مرد", value: "MALE" },
  { _id: "1", name: "زن", value: "FEMALE" },
];
const marital: IItem[] = [
  { name: "مجرد", value: "SINGLE" },
  { name: "متاهل", value: "MARRIED" },
];

export default Create;
